import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/video/home-reel.mp4")